/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_IsolationInputs */

const en_mk_mx_isolation = /** @type {(inputs: Mk_Mx_IsolationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data isolation between companies`)
};

const id_mk_mx_isolation = /** @type {(inputs: Mk_Mx_IsolationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Isolasi data antar perusahaan`)
};

/**
* | output |
* | --- |
* | "Data isolation between companies" |
*
* @param {Mk_Mx_IsolationInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_isolation = /** @type {((inputs?: Mk_Mx_IsolationInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_IsolationInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_isolation(inputs)
	return en_mk_mx_isolation(inputs)
});